import { api } from '@/lib/api'

/**
 * @returns {Promise<object>}
 */
export async function fetchOnlineBookingSettings() {
  const { data } = await api.get('/masters/online-booking-settings')
  return data.data.online_booking
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<object>}
 */
export async function updateOnlineBookingSettings(payload) {
  const { data } = await api.put('/masters/online-booking-settings', payload)
  return data.data.online_booking
}
